<template>
  <v-card elevation="0">
    <v-card-title>Параметры настройки шлюза доставки</v-card-title>
    <v-card-text>
      <v-row class="d-flex" dense>
        <v-col class="col-6">
          <v-textarea
            v-model="tokenList"
            label="Список токенов подключения (каждый токен на отдельной строке)"
            auto-grow
            rows="1"
            >
          </v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-6">
          <v-switch
            v-model="proCartConfig.enable_items_verification"
            label="Включить проверку кодов блюд при создании заказа"
          ></v-switch>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            v-model="proCartConfig.timeout_statepolling"
            :rules="[v => (/^\d+$/.test(v)) && (v >= 1) || 'Введите количество секунд']"
            label="Задержка опроса r_keeper на предмет изменений в заказах (секунд)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-6">
          <v-switch
            v-model="proCartConfig.use_internet_pay_tags"
            label="Заполнять теги для интернет платежей"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row v-if="proCartConfig.use_internet_pay_tags">
        <v-col class="col-6">
          <v-text-field
            v-model="proCartConfig.def_site_url_1187"
            label="Адрес сайта (Место расчетов)"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            v-model="proCartConfig.def_contact_1008"
            label="Контактные данные покупателя"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  props: ["proCartConfig"],

  computed: {
    tokenList: {
      get() {
        return this.proCartConfig.token_list.join('\n');
      },

      set(value) {
        this.proCartConfig.token_list = value.split('\n').map(x => x.trim()).filter(x => x != '');
      },
    },
  },
};
</script>

<style>
</style>